import {
  replaceUrlParam,
  findTabs,
  findComponentByPluginName,
  findCurrentComponentPathInLayoutByRectId,
  getHtmlPlainText,
  simpleDeepClone,
  isFieldAllEmpty
} from "@/utils"
import { fixComponent } from "@/utils/analysisTypeId"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { getSyetemModuleJson } from "@/utils/initEv.js"
import cxBreadCrumbs from "../../materials/breadCrumbs"
/**
 * 列表页插件
 */
class ListPage {
  constructor(vue) {
    this.context = vue
    this.dataLayoutOptions = null
    this.request_prefix = this.context.request_prefix
    this.appId = this.context.$store.state.states.getDataPageIds.appId
    this.homePageId = this.context.$store.state.states.getDataPageIds.homePageId
    this.listPageId = this.context.$store.state.states.getDataPageIds.listPageId
    this.subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    this.name = this.subPage.listPageSetting.name
    this.showApplicationName = this.subPage.listPageSetting.showApplicationName
    this.showBreadCrumbs = this.subPage.listPageSetting.showBreadCrumbs
    this.showNavMenu = this.subPage.listPageSetting.showNavMenu
    this.showSearchComponent = this.subPage.listPageSetting.showSearchComponent
    this.containerId = 0
    this.restUrl = null // 分类数据
    this.restDataUrl = "" // 请求数据的接口地址
    this.pageNum = 1 // 请求数据的页数
    this.dataGridFlag = false // 是否存在数据列表组件
    this.layoutId = null // 自由布局组件在通栏中的位置
    this.introductionId = null // 简介在通栏中的位置
    this.navMenuId = null // 多级导航在通栏中的位置
    this.breadCrumbsId = null // 面包屑在通栏中的位置
    this.simpleSearchInputId = null // 搜索输入框id
    this.simpleSearchButtonId = null // 搜索按钮id
    this.isPhoneFullScreen = this.context.$store.state[this.request_prefix].page.isPhoneFullScreen // 翻页模版标识
    this.asyncStatus = true
    this.isLocalData = true // 是否是本地数据，还是外接数据，如果engineInstance.source > 1，则是外接数据, 否则是本地数据
    this.defaultModuleId = ["development", "test"].includes(process.env.NODE_ENV)
      ? "0ff11d4d1b5b2111ee1abc352b5e251c9164"
      : "0ff11d4d1b5b2111ee1abc352b5e251c9164" // 默认模板的id
    this.appNameStr = {}
    // 不请求get-classify接口，为了获取外接数据源分类的数据
    this.noGetClassify = this.context.$store.state[this.request_prefix].page.pluginName?.includes("getRestClassifyPlugin")
  }
  async init() {
    sessionStorage.removeItem("hasBreadCrumbs")
    sessionStorage.removeItem("hasNavMenuVertical")
    sessionStorage.removeItem("hasSearchComponent")
    // 处理翻页模版转常页
    if (this.isPhoneFullScreen) {
      this.context.$store.dispatch(this.request_prefix + "/changePhoneFullScreen", false)
      this.context.$store.dispatch(this.request_prefix + "/changePageLayoutType", "layOut")
      this.context.$store.dispatch(this.request_prefix + "/changeOnlyH5Template", true)
    }
    this.watchLayoutSize()
    this.initLayoutData()
    // 先获取分类数据
    const { pageId, wfwfid, websiteId } = this.context.$store.state.states.getDataPageIds
    const { restUrl } = await getAppointCacheData.call(this.context, pageId, wfwfid, websiteId, this.appId)
    if (restUrl && restUrl.data && restUrl.data.data && restUrl.data.data.engineInstance) {
      this.restDataUrl = restUrl.data.data.restDataUrl
      if (restUrl.data.data.engineInstance.source > 1) {
        this.isLocalData = false
      }
      const name =
        getHtmlPlainText(restUrl.data.data.engineInstance.appName) ||
        getHtmlPlainText(restUrl.data.data.engineInstance.name)
      this.context.$store.commit("states/changeSubPageName", name)
      this.setNameToClassify([{}], name)
    }
    this.restUrl = restUrl
    this.engineId = restUrl?.data?.data?.engineInstance?.publicId

    // 当前分类下的第一个分类的id
    let navMenuData,
      targetData = []
    navMenuData = this.restUrl.data.data.generalDataTypes
    this.recursiveFindDataTypes(navMenuData, targetData)
    this.defaultClassifyId = navMenuData[0]?.publicId

    // 请求数据的url组装
    this.restDataUrl = this.restDataUrl.replace("typeId=", "t=").replace("engineInstanceId=", "e=")
    this.restDataUrl = replaceUrlParam(this.restDataUrl, "t", this.defaultClassifyId)

    this.preComponentPageidSet()
    // 初始化组件
    this.context.$eventBus.$on("listPage-component-init", msg => {
      switch (msg.type) {
        case "cxNoteEditor":
          // this.initIntroductionData(msg.type + "_" + msg.businessId)
          break
        case "cxNavMenuVertical":
          this.initNavMenuData(msg.type + "_" + msg.businessId)
          break
        case "cxBreadCrumbs":
          this.getBreadCrumbsData(this.defaultClassifyId).then(res => {
            this.initBreadCrumbsData(res, msg.type + "_" + msg.businessId)
          })
          break
        case "cxMultiFilter":
          this.initMultiFilterData(msg.type + "_" + msg.businessId)
          break
        case "cxDataGrid":
          this.dataGridFlag = true
          if (msg.pageNum) this.pageNum = msg.pageNum
          this.initDataGrid(msg.type + "_" + msg.businessId)
          break
        case "cxDatePicker":
          this.initCxDatePickerData(msg.type + "_" + msg.businessId)
          break
        case "cxCalendar":
          this.initCxCalendarData(msg.type + "_" + msg.businessId)
          break
        case "cxSort":
          this.initSortData(msg.type + "_" + msg.businessId)
          break
      }
    })
    this.addSubPageStyleEvent()
  }
  // 监听通栏的数量变化，更改id
  watchLayoutSize() {
    const self = this
    this.context.$watch(
      function () {
        return self.context.$store.state[self.request_prefix].page.pageLayoutList.length
      },
      async function () {
        const layout = self.context.$store.state[self.request_prefix].page.pageLayoutList
        const emptyLayoutRectAttr = self.findComponent("emptyLayoutComponent")
        if (emptyLayoutRectAttr) {
          const path = findCurrentComponentPathInLayoutByRectId(layout, emptyLayoutRectAttr.rect_id).join("_")
          self.layoutId = path
        }
        const noteRectAttr = self.findComponent("cxNoteEditor")
        if (noteRectAttr) {
          const path = findCurrentComponentPathInLayoutByRectId(layout, noteRectAttr.rect_id).join("_")
          self.introductionId = path
        }
        const navMenuRectAttr = self.findComponent("cxNavMenuVertical")
        if (navMenuRectAttr) {
          const path = findCurrentComponentPathInLayoutByRectId(layout, navMenuRectAttr.rect_id).join("_")
          self.navMenuId = path
        }
        const BreadRectAttr = self.findComponent("cxBreadCrumbs")
        if (BreadRectAttr) {
          const path = findCurrentComponentPathInLayoutByRectId(layout, BreadRectAttr.rect_id).join("_")
          self.breadCrumbsId = path
        }
        const simpleSearchRectAttr = self.findSearchComponent()
        if (simpleSearchRectAttr) {
          const uid = simpleSearchRectAttr.options?.rows[0]?.cols[0]?.uid
          const idPrefix = `container_id_${self.containerId}-rect_id_${simpleSearchRectAttr.rect_id}-uid_${uid}-elementInLayoutId_`
          self.simpleSearchInputId =
            idPrefix + simpleSearchRectAttr?.options?.rows[0]?.cols[0].elementOptions?.find(item => item.innerElement === "cxInput").elementInLayoutId
          self.simpleSearchButtonId =
            idPrefix + simpleSearchRectAttr?.options?.rows[0]?.cols[0].elementOptions?.find(item => item.innerElement === "cxButton").elementInLayoutId
        }
      },
      {
        immediate: true
      }
    )
  }
  // 列表页预设组件preComponent添加所属的pageid
  preComponentPageidSet() {
    const self = this
    let children = self.context.$store.state[self.request_prefix].page.children[0].children
    if (self.restUrl.data.data.engineInstance) {
      let sourcePageId = self.restUrl.data.data.engineInstance.pageId
      children.forEach(item => {
        if (item.preComponent === true) {
          item.sourcePageId = sourcePageId
        }
      })
    }
  }
  addSubPageStyleEvent() {
    const self = this
    let cxNavMenuVertical = null
    Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
      if (key.indexOf("cxNavMenuVertical") > -1) {
        cxNavMenuVertical = this.context.$subPageEvent.contexts[key]
      }
    })
    this.context.$eventBus.$on("updateSubPageStyle", msg => {
      let navMenu = null
      let temp = null
      let classify = "default"
      const emptyLayout = self.findComponent("emptyLayoutComponent")
      if (cxNavMenuVertical) {
        navMenu = cxNavMenuVertical
      } else {
        const titles = emptyLayout.options.titleOptions || []
        titles.forEach(title => {
          title.elementOptions.forEach(element => {
            if (element.type === "navMenuVertical") {
              navMenu = element
            }
          })
        })
      }
      if (navMenu) {
        // 保存前，需要遍历一下，删除以前是独立样式，切换成统一样式的分类
        const storeOptions = emptyLayout.storeOptions || {}
        for(let i in storeOptions) {
          if(i !== "default") {
            const asyncStatus = navMenu.options.asyncStatus === false ? false : true
            const { value: generalDataTypesItem, parent } = self.findCurrentNavMenuData(
              self.restUrl.data.data.generalDataTypes,
              i
            )
            let isDefault = false
            if (generalDataTypesItem) {
              const moduleId = generalDataTypesItem.moduleId || parent?.moduleId || ""
              isDefault = asyncStatus ? moduleId === self.defaultModuleId || moduleId === "" : false
            }
            if(isDefault) {
              const data = {
                container_id: self.containerId,
                rect_id: emptyLayout.rect_id,
                classify: i,
                options: null
              }
              self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
            }
          }
        }
        const asyncStatus = navMenu.options.asyncStatus === false ? false : true
        const { value: generalDataTypesItem, parent } = self.findCurrentNavMenuData(
          self.restUrl.data.data.generalDataTypes,
          navMenu.options.value
        )
        if (generalDataTypesItem) {
          const moduleId = generalDataTypesItem.moduleId || parent?.moduleId || ""
          classify = asyncStatus
            ? moduleId === self.defaultModuleId || moduleId === ""
              ? "default"
              : navMenu.options.value
            : navMenu.options.value
        }
      }
      temp = simpleDeepClone(emptyLayout.options)
      const data = {
        container_id: self.containerId,
        rect_id: emptyLayout.rect_id,
        classify,
        options: temp
      }
      self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
    })
  }
  initCxDatePickerData(key) {
    // 初始化日期选择器组件
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageDatePickerData(this)
    }
  }
  initCxCalendarData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageCalendarData(this)
    }
  }
  initSortData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageSortData(this)
    }
  }
  initCxPaginationData(totalRecords, pageSize) {
    Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
      if (key.indexOf("cxPagination") !== -1) {
        this.context.$subPageEvent.contexts[key].initListPagePaginationData(totalRecords, pageSize)
      }
    })
  }
  initOldNavMenuWatcher(rectId) {
    const self = this
    this.context.$watch(
      function () {
        let navMenu = null
        const emptyLayoutComponent = self.context.$store.state[self.request_prefix].page.children[0].children.find(
          rect => rect.rect_id === rectId
        )
        if (!emptyLayoutComponent) return emptyLayoutComponent
        const titles = emptyLayoutComponent.options.titleOptions || []
        titles.forEach(title => {
          title.elementOptions.forEach(element => {
            if (element.type === "navMenuVertical") {
              navMenu = element
            }
          })
        })
        // undefined也视为true
        self.asyncStatus = navMenu?.options.asyncStatus === false ? false : true
        const value = navMenu?.options.value
        if (value) {
          sessionStorage.setItem("navMenuValue", value)
        }
        return navMenu?.options.value
      },
      async function (newVal, oldVal) {
        // 默认数据不是id的，不操作
        const reg = /^[a-zA-Z0-9]*$/
        if (!reg.test(newVal)) {
          return
        }
        // openTarget 1 当前窗口 2 新窗口
        // openType 1 自定义页面 2 链接地址
        // showType openType === 1 时  【0/1：列表、2：简介、3：简介+列表 4：简介+分类列】
        const { value: generalDataTypesItem, parent } = self.findCurrentNavMenuData(self.restUrl.data.data.generalDataTypes, newVal)
        if (!generalDataTypesItem) {
          return
        }
        self.getAssembleClassifylData(newVal)
        const moduleId = generalDataTypesItem.moduleId || parent?.moduleId || ""
        // 需要根据当前多级导航选中的节点类型，决定显示内容
        const emptyLayout = self.findComponent("emptyLayoutComponent")
        const ids = {
          container_id: self.containerId,
          rect_id: emptyLayout.rect_id
        }
        // 没有存储默认配置，需要存储一份，用于恢复还原
        if (emptyLayout && !emptyLayout.hasOwnProperty("storeOptions")) {
          const { rows } = simpleDeepClone(emptyLayout.options)
          const temp = {
            rows
          }
          // 如果模板的高度为百分比，需要记录下单元格高度，进行还原
          // const parentLayout = self.context.getAttrById(
          //   self.context.$store.state[self.context.request_prefix],
          //   { pageLayoutId: self.layoutId },
          //   "pageLayout"
          // )
          // const layoutHeight = Number(parentLayout.options.height)
          // if (layoutHeight) {
          //   temp.layoutHeight = layoutHeight
          // }
          const data = {
            ...ids,
            classify: "default",
            options: temp
          }
          self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
        }
        // 把切换前的标签内容存起来
        if (oldVal && reg.test(oldVal)) {
          let val = oldVal
          const generalDataTypesItem = self.findCurrentNavMenuData(self.restUrl.data.data.generalDataTypes, oldVal)
          // 开启了自动同步，保存到默认样式
          if (
            (generalDataTypesItem?.moduleId === self.defaultModuleId || generalDataTypesItem?.moduleId === "") &&
            self.asyncStatus
          ) {
            // 开启了同步，需要将单独保存内容删除
            const data = {
              ...ids,
              classify: val,
              options: null
            }
            self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
            val = "default"
          }
          const { rows, encId } = simpleDeepClone(emptyLayout.options)
          const temp = {
            rows
          }
          if (encId) {
            temp.encId = encId
          }
          // const parentLayout = self.context.getAttrById(
          //   self.context.$store.state[self.context.request_prefix],
          //   { pageLayoutId: self.layoutId },
          //   "pageLayout"
          // )
          // const layoutHeight = Number(parentLayout.options.height)
          // if (layoutHeight) {
          //   temp.layoutHeight = layoutHeight
          // }
          const data = {
            ...ids,
            classify: val,
            options: temp
          }
          self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
        }
        const encId = moduleId === self.defaultModuleId ? "" : moduleId
        const storeOptions = emptyLayout.storeOptions[newVal]
        if (!encId && (!storeOptions || self.asyncStatus)) {
          // 后台没有绑定样式，无记录或开启了同步
          const tmpData = { ...emptyLayout.options, ...simpleDeepClone(emptyLayout.storeOptions.default) }
          const data = {
            ...ids,
            options: tmpData
          }
          self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
        } else if (
          encId &&
          storeOptions &&
          (encId === storeOptions.encId || (storeOptions.encIdChanged && encId === storeOptions.encIdChanged))
        ) {
          // 有样式记录，且样式和已保存样式一致，直接取历史数据
          const tmpData = { ...emptyLayout.options, ...simpleDeepClone(storeOptions) }
          const data = {
            ...ids,
            options: tmpData
          }
          self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
        } else if ((encId && !storeOptions) || (encId && storeOptions && encId !== storeOptions.encId)) {
          // 后台绑定了样式，无记录；后台绑定了样式，有记录，但是样式不一致
          const tmpData = emptyLayout.options
          const _attribute = await getSyetemModuleJson(encId)
          tmpData.rows = _attribute.options.rows
          tmpData.encId = encId
          const data = {
            ...ids,
            options: tmpData
          }
          // const layoutHeight = Number(_attribute.options.height)
          // if (layoutHeight) {
          //   // 自由布局本身高度还有内容，这里默认加50
          //   tmpData.layoutHeight = layoutHeight + 50
          // }
          self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
        } else if (!encId && storeOptions) {
          // 后台没有绑定样式，有记录
          const tmpData = { ...emptyLayout.options, ...simpleDeepClone(storeOptions) }
          const data = {
            ...ids,
            options: tmpData
          }
          self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
        }
        self.context.$nextTick(() => {
          // 修改样式后，要重置高度
          // const parentLayout = self.context.getAttrById(
          //   self.context.$store.state[self.context.request_prefix],
          //   { pageLayoutId: self.layoutId },
          //   "pageLayout"
          // )
          // const layoutHeight = Number(emptyLayout.options.layoutHeight)
          // if (layoutHeight) {
          //   parentLayout.options.height = layoutHeight
          // }
          self.resetCountHeight([self.layoutId])
        })
      },
      {
        immediate: true
      }
    )
  }
  // 新样式模板
  initNavMenuWatcher(options) {
    const self = this
    this.context.$watch(
      function () {
        // undefined也视为true
        self.asyncStatus = options.asyncStatus === false ? false : true
        const value = options.value
        if (value) {
          sessionStorage.setItem("navMenuValue", value)
        }
        return value
      },
      async function (newVal, oldVal) {
        // openTarget 1 当前窗口 2 新窗口
        // openType 1 自定义页面 2 链接地址
        // showType openType === 1 时  【0/1：列表、2：简介、3：简介+列表 4：简介+分类列】
        const { value: generalDataTypesItem, parent } = self.findCurrentNavMenuData(self.restUrl.data.data.generalDataTypes, newVal)
        if (!generalDataTypesItem) {
          return
        }
        self.getAssembleClassifylData(newVal, generalDataTypesItem)
        const { showType, introduction, relId } = generalDataTypesItem
        const moduleId = generalDataTypesItem.moduleId || parent?.moduleId || ""
        // 需要根据当前多级导航选中的节点类型，决定显示内容
        let layoutType = false
        let introductionType = false
        switch (showType) {
          case 0:
          case 1: // 列表
            layoutType = true
            introductionType = false
            break
          case 2: // 简介
            layoutType = false
            introductionType = true
            break
          case 3: // 简介+列表
            layoutType = true
            introductionType = true
            break
          case 4: // 简介+分类列表
            layoutType = true
            introductionType = true
            break
        }

        console.log("initNavMenuWatcher")

        // 更新this.restDataUrl
        if (self.dataGridFlag && layoutType) {
          self.restDataUrl = replaceUrlParam(self.restDataUrl, "t", newVal)
          self.initDataGrid()
        }

        self.initIntroductionData(introduction, introductionType)
        // 通知面包屑更新数据
        self.getBreadCrumbsData(newVal).then(res => {
          self.initBreadCrumbsData(res)
        })

        if (!this.dataGridFlag) {
          const emptyLayout = self.findComponent("emptyLayoutComponent")
          if (!emptyLayout) {
            return
          }
          const emptyLayoutComponent_rect_id = emptyLayout?.rect_id
          const ids = {
            container_id: self.containerId,
            rect_id: emptyLayout?.rect_id
          }
          // 没有存储默认配置，需要存储一份，用于恢复还原
          if (emptyLayout && !emptyLayout.hasOwnProperty("storeOptions")) {
            const temp = simpleDeepClone(emptyLayout.options)
            const data = {
              ...ids,
              classify: "default",
              options: temp
            }
            // 如果模板的高度为百分比，需要记录下单元格高度，进行还原
            // if (temp.heightType === "%") {
            //   let parentLayout = self.context.getAttrById(
            //     self.context.$store.state[self.context.request_prefix],
            //     { pageLayoutId: self.layoutId },
            //     "pageLayout"
            //   )
            //   if (parentLayout.options.height) {
            //     temp.layoutHeight = parentLayout.options.height
            //   }
            // }
            self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
          }
          // 把切换前的标签内容存起来
          if (oldVal) {
            let val = oldVal
            const generalDataTypesItem = self.findCurrentNavMenuData(self.restUrl.data.data.generalDataTypes, oldVal)
            // 开启了自动同步，保存到默认样式
            if (
              (generalDataTypesItem?.moduleId === self.defaultModuleId || generalDataTypesItem?.moduleId === "") &&
              self.asyncStatus
            ) {
              // 开启了同步，需要将单独保存内容删除
              const data = {
                ...ids,
                classify: val,
                options: null
              }
              self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
              val = "default"
            }
            const temp = simpleDeepClone(emptyLayout.options)
            const data = {
              ...ids,
              classify: val,
              options: temp
            }
            // const parentLayout = self.context.getAttrById(
            //   self.context.$store.state[self.context.request_prefix],
            //   { pageLayoutId: self.layoutId },
            //   "pageLayout"
            // )
            // const layoutHeight = Number(parentLayout.options.height)
            // if (layoutHeight) {
            //   temp.layoutHeight = layoutHeight
            //   if (temp.heightType !== "%") {
            //     temp.height = layoutHeight
            //   }
            // }
            self.context.$store.dispatch(self.context.request_prefix + "/changeStoreOptions", data)
          }
          const encId = moduleId === self.defaultModuleId ? "" : moduleId
          const storeOptions = emptyLayout.storeOptions[newVal]
          console.log("------selected encId:", encId)
          if (!encId && (!storeOptions || self.asyncStatus)) {
            // 后台没有绑定样式，无记录或开启了同步
            let tmpData = simpleDeepClone(emptyLayout.storeOptions.default)
            // 兼容旧数据格式，直接在当前options上修改row属性
            if(!tmpData.hasOwnProperty("titleOptions") && tmpData.rows) {
              let rows = tmpData.rows
              tmpData = emptyLayout.options
              tmpData.rows = rows
            }
            tmpData.appId = emptyLayout.options.appId
            const data = {
              ...ids,
              options: tmpData
            }
            self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
          } else if (
            encId &&
            storeOptions &&
            (encId === storeOptions.encId || (storeOptions.encIdChanged && encId === storeOptions.encIdChanged))
          ) {
            // 有样式记录，且样式和已保存样式一致，直接取历史数据
            let tmpData = simpleDeepClone(storeOptions)
            // 兼容旧数据格式，直接在当前options上修改row属性
            if(!tmpData.hasOwnProperty("titleOptions") && tmpData.rows) {
              let rows = tmpData.rows
              tmpData = emptyLayout.options
              tmpData.rows = rows
            }
            tmpData.appId = emptyLayout.options.appId
            const data = {
              ...ids,
              options: tmpData
            }
            self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
          } else if ((encId && !storeOptions) || (encId && storeOptions && encId !== storeOptions.encId)) {
            // 后台绑定了样式，无记录；后台绑定了样式，有记录，但是样式不一致
            const curOptions = emptyLayout.options
            const _attribute = await getSyetemModuleJson(encId)
            const tmpData = _attribute.options
            tmpData.rect_id = _attribute.rect_id
            tmpData.shape = _attribute.shape
            tmpData.encId = encId
            tmpData.left = curOptions.left
            tmpData.leftType = curOptions.leftType
            tmpData.top = curOptions.top
            tmpData.topType = curOptions.topType
            tmpData.margin = curOptions.margin
            tmpData.offset = curOptions.offset
            tmpData.isQuickSite = curOptions.isQuickSite
            //自由布局组件在切换样式的时候保证外接数据源和原来的一致
            tmpData.appId = curOptions.appId
            tmpData.engineInstanceId = curOptions.engineInstanceId
            tmpData.engineInstanceAppId = curOptions.engineInstanceAppId
            tmpData.moduleId = curOptions.moduleId
            tmpData.myFetchParam = curOptions.myFetchParam
            // 切换样式保持应用名称不变
            tmpData.name = curOptions.name
            // 头部和底部默认不显示
            tmpData.titleOptions[0].isShow = false
            tmpData.titleOptions[1].isShow = false
            const data = {
              ...ids,
              options: tmpData
            }
            // 如果模板的高度为百分比，需要记录下单元格高度，进行还原
            // if (tmpData.heightType === "%") {
            //   let parentLayout = self.context.getAttrById(
            //     self.context.$store.state[self.context.request_prefix],
            //     { pageLayoutId: self.layoutId },
            //     "pageLayout"
            //   )
            //   if (parentLayout.options.height) {
            //     tmpData.layoutHeight = parentLayout.options.height
            //   }
            // }
            self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
          } else if (!encId && storeOptions) {
            // 后台没有绑定样式，有记录
            let tmpData = simpleDeepClone(storeOptions)
            // 兼容旧数据格式，直接在当前options上修改row属性
            if(!tmpData.hasOwnProperty("titleOptions") && tmpData.rows) {
              let rows = tmpData.rows
              tmpData = emptyLayout.options
              tmpData.rows = rows
            }
            tmpData.appId = emptyLayout.options.appId
            const data = {
              ...ids,
              options: tmpData
            }
            self.context.$store.dispatch(self.context.request_prefix + "/changeAllOptions", data)
          }
          const oldOption = emptyLayout.storeOptions[oldVal] || emptyLayout.storeOptions.default
          // 不同的样式直接切换，不更新classify
          if (oldOption.encId === (encId || emptyLayout.storeOptions.default.encId)) {
            self.getAssembleClassifylData(newVal, generalDataTypesItem)
          }

          self.context.$nextTick(() => {
            // 列表和简介的显隐
            self.context.$changeOptionsEV(
              layoutType,
              "isShow",
              false,
              null,
              {
                pageLayoutId: self.layoutId
              },
              true
            )
            // 修改样式后，要重置高度
            // const parentLayout = self.context.getAttrById(
            //   self.context.$store.state[self.context.request_prefix],
            //   { pageLayoutId: self.layoutId },
            //   "pageLayout"
            // )
            // if (emptyLayout.options.heightType === "%") {
            //   const layoutHeight = emptyLayout.options.layoutHeight
            //   layoutHeight && (parentLayout.options.height = layoutHeight)
            // } else {
            //   parentLayout.options.height = emptyLayout.options.height
            // }
            // self.resetCountHeight([self.introductionId])
            // 通知自由布局更新数据
            self.context.$eventBus.$emit(
              `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
              {
                typeId: newVal,
                relIds: relId
              }
            )
          })
        }
      },
      {
        immediate: true
      }
    )
  }
  // 重新设置父元素的高度
  resetCountHeight(pageLayoutIdsArr) {
    let minLayout = []
    pageLayoutIdsArr.forEach(layoutIds => {
      if (layoutIds) {
        let idArr = layoutIds.split("_")
        minLayout = idArr.length > minLayout.length ? idArr : minLayout
      }
    })
    let curIndex = minLayout[minLayout.length - 1]
    minLayout.pop()
    if (minLayout.length > 0) {
      this.setParentLayoutH(minLayout.join("_"), curIndex)
    }
  }
  setNameToClassify(result, name) {
    const appName = name || "图文"
    const componentShape = fixComponent("appName", appName)
    let str = {}
    str.componentShape = componentShape
    str.value = "" + appName
    str.key = "应用名称"
    result[0].appName = str
    this.appNameStr = str
    window.localStorage.setItem(`classifyDetailData-` + this.appId, JSON.stringify(result))
  }
  setParentLayoutH(parentId, curIndex) {
    let parentH = 0
    let ids = parentId.split("_")
    let lastIndex = parseInt(ids[ids.length - 1])
    let parentLayout = this.context.getAttrById(
      this.context.$store.state[this.context.request_prefix],
      { container_id: this.containerId, pageLayoutId: parentId },
      "pageLayout"
    ).layout
    //  列表页中 只有行 隐藏，展示的情况
    if (parentLayout.rows.length > 0) {
      parentLayout.rows.forEach(item => {
        if (item.options.isShow) {
          parentH += parseFloat(item.options.height ?? 0)
        }
      })
    } else if (parentLayout.cols.length > 0) {
      parentH = parseFloat(parentLayout.cols[curIndex].options.height ?? 0)
      parentLayout.cols.forEach((item, index) => {
        this.context.$changeOptionsEV(
          parentH,
          "height",
          false,
          "",
          {
            container_id: this.id,
            pageLayoutId: parentId + "_" + index
          },
          true
        )
        let editProp = parentH / parseFloat(item.options.height ?? 0)
        this.setChildLayoutH(editProp, item, parentId + "_" + index)
      })
    } else {
      return
    }
    this.context.$changeOptionsEV(
      parentH,
      "height",
      false,
      "",
      {
        container_id: this.id,
        pageLayoutId: parentId
      },
      true
    )
    let newIds = parentId.split("_")
    newIds.splice(newIds.length - 1, 1)
    if (newIds.length > 0) {
      newIds = newIds.join("_")
      this.setParentLayoutH(newIds, lastIndex)
    }
  }
  // 设置子元素的高度
  setChildLayoutH(editProp, child, parentId) {
    // parentId 为空时报错
    if (
      (child.layout.rows.length === 0 && child.layout.cols.length === 0) ||
      typeof parentId === "undefined" ||
      parentId === null
    ) {
      // 没有子元素啦
      return
    }
    let curCellIsRow = child.layout.rows.length > 0 ? true : false
    let layout = curCellIsRow ? child.layout.rows : child.layout.cols
    layout.forEach((item, index) => {
      let childHeight = parseFloat(item.options.height) * editProp
      this.context.$changeOptionsEV(
        childHeight,
        "height",
        false,
        "",
        {
          container_id: this.id,
          pageLayoutId: parentId + "_" + index
        },
        true
      )
      this.setChildLayoutH(editProp, item)
    })
  }
  findCurrentNavMenuData(generalDataTypes, value) {
    let result = { value: undefined, parent: null }
    this.findCurrentNavMenuDataHandle(generalDataTypes, value, result, parent = null)
    return result
  }
  // 根据多级导航的选中publicId找到当前节点的数据
  findCurrentNavMenuDataHandle(generalDataTypes, value, result, parent) {
    for (let i = 0; i < generalDataTypes.length; i++) {
      if (generalDataTypes[i].publicId === value) {
        result.value = generalDataTypes[i]
        result.parent = parent
        return
      } else {
        if (generalDataTypes[i].subGeneralDataTypes.length > 0) {
          this.findCurrentNavMenuDataHandle(generalDataTypes[i].subGeneralDataTypes, value, result, generalDataTypes[i])
        }
      }
    }
  }
  // 根据组件类型找到列表页中的组件
  findComponent(type) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.shape === type && !rect.options?.pluginName?.includes("searchComponentPlugin") && !rect.options?.pluginName?.includes("loginLayoutComponent")
    })[0]
  }

  // 根据组件插件找到列表页中的组件
  findComponentByPlugin(pluginName) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.pluginName?.includes(pluginName)
    })[0]
  }

  // 找到简单搜索组件
  findSearchComponent() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.pluginName?.includes("ListPageSearchComponentPlugin")
    })[0]
  }
  initSimpleSearchWatcher() {
    // 获取展示列表的id
    const simpleSearchComponet = this.findSearchComponent()
    const ids = {
      container_id: this.containerId,
      rect_id: simpleSearchComponet?.rect_id
    }
    if (!this.showSearchComponent) {
      this.context.$changeOptionsEV(0, "opacity", false, null, { ...ids }, true)
      this.context.$changeOptionsEV(false, "isShow", false, null, { ...ids }, true)
      return
    } else {
      this.context.$changeOptionsEV(100, "opacity", false, null, { ...ids }, true)
      this.context.$changeOptionsEV(true, "isShow", false, null, { ...ids }, true)
    }
    if (simpleSearchComponet) {
      sessionStorage.setItem("hasSearchComponent", "1")
    }
    if (!simpleSearchComponet || !this.showSearchComponent) return
    // 监听搜索输入框值变化
    setTimeout(() => {
      const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
      if (searchButton) {
        this.clickSearchButtonBind = this.clickSearchButton.bind(this)
        searchButton.addEventListener("click", this.clickSearchButtonBind, true)
      }
    }, 200)
  }
  // 获取面包屑数据
  async getBreadCrumbsData(typeId) {
    return this.context.$API.queryCrumbData({
      typeId: typeId ? typeId : 0,
      e: this.engineId
    })
  }
  // 初始化自由布局组件
  initLayoutData() {
    const rectAttr = this.findComponent("emptyLayoutComponent")
    if (!rectAttr) return
    this.dataLayoutOptions = rectAttr
    // 初始化列表页中的列表
    this.context.$changeOptionsEV(
      true,
      "noCacheComponent",
      false,
      null,
      {
        container_id: this.containerId,
        rect_id: rectAttr.rect_id
      },
      true
    )
    this.context.$changeOptionsEV(
      this.appId,
      "appId",
      false,
      null,
      {
        container_id: this.containerId,
        rect_id: rectAttr.rect_id
      },
      true
    )
    this.context.$changeOptionsEV(
      true,
      "isShow",
      false,
      null,
      {
        pageLayoutId: this.layoutId
      },
      true
    )
    // 老数据兼容
    this.setTitleComponentsIsShow(rectAttr, this.showBreadCrumbs, "breadCrumbs")
    this.setTitleComponentsIsShow(rectAttr, this.showNavMenu, "navMenuVertical")
  }
  // 初始化breadCrumbs面包屑组件
  initBreadCrumbsData(breadCrumbsData, key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageBreadCrumbsData(
        this.showBreadCrumbs,
        breadCrumbsData,
        this.restUrl
      )
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxBreadCrumbs") !== -1) {
          this.context.$subPageEvent.contexts[key].initListPageBreadCrumbsData(
            this.showBreadCrumbs,
            breadCrumbsData,
            this.restUrl
          )
        }
      })
    }
  }
  // 初始化多级导航组件
  initNavMenuData(key) {
    // const navRect =  this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
    //   return rect.rect_id === this.context.$subPageEvent.contexts[key].myid.rect_id && rect.shape === "cxNavMenuVertical"
    // })
    // if (navRect.length === 0) return // 当前树形菜单是头部导航菜单，不参与数据列表的数据联动
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageNavMenuData(this)
      this.initNavMenuWatcher(this.context.$subPageEvent.contexts[key].options)
      // 如果是移动端，找到控制导航的抽屉按钮
      if (this.request_prefix === "appStage") {
        let appStageNavMenuBtnAttr = this.findComponentByPlugin("listPageNavMenuDrawerPlugin")
        let appStageNavMenuBtnIds = {
          container_id: this.containerId,
          rect_id: appStageNavMenuBtnAttr?.rect_id
        }
        if (!this.showNavMenu && appStageNavMenuBtnAttr) {
          this.context.$changeOptionsEV(0, "opacity", false, null, { ...appStageNavMenuBtnIds }, true)
        } else if (this.showNavMenu && appStageNavMenuBtnAttr) {
          this.context.$changeOptionsEV(100, "opacity", false, null, { ...appStageNavMenuBtnIds }, true)
        }
      }
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxNavMenuVertical") !== -1) {
          this.context.$subPageEvent.contexts[key].initListPageNavMenuData(this)
        }
      })
    }
    // 新的导航，通过事件更新数据，这里老的入口先屏蔽掉
    //=====================================================兼容旧数据========================================================
    // let rectAttr = this.findComponent("cxNavMenuVertical")
    // 兼容之前的老数据，导航和内容都是放自由布局里
    // if (!rectAttr) {
    //   const emptyLayoutComponent = this.findComponent("emptyLayoutComponent")
    //   this.initOldNavMenuWatcher(emptyLayoutComponent.rect_id)
    //   return
    // }
    //=====================================================兼容旧数据========================================================
    // sessionStorage.setItem("hasNavMenuVertical", "1")
    // let ids = {
    //   container_id: this.containerId,
    //   rect_id: rectAttr.rect_id
    // }
    // // 产品要求 不显示导航菜单时 右侧数据所占通栏宽度100%
    // let layoutId = this.layoutId ? this.layoutId.substr(0, 5) : ""
    // if (!this.showNavMenu) {
    //   if (this.request_prefix === "appStage" && appStageNavMenuBtnAttr) {
    //     this.context.$changeOptionsEV(0, "opacity", false, null, { ...appStageNavMenuBtnIds }, true)
    //   } else {
    //     this.context.$changeOptionsEV(0, "opacity", false, null, { ...ids }, true)
    //   }
    //   this.context.$changeOptionsEV(
    //     false,
    //     "isShow",
    //     false,
    //     null,
    //     {
    //       pageLayoutId: this.navMenuId
    //     },
    //     true
    //   )
    //   layoutId
    //     ? this.context.$changeOptionsEV(
    //         "100%",
    //         "width",
    //         false,
    //         null,
    //         {
    //           pageLayoutId: layoutId
    //         },
    //         true
    //       )
    //     : ""
    //   return
    // } else {
    //   if (this.request_prefix === "appStage" && appStageNavMenuBtnAttr) {
    //     this.context.$changeOptionsEV(100, "opacity", false, null, { ...appStageNavMenuBtnIds }, true)
    //   } else {
    //     this.context.$changeOptionsEV(100, "opacity", false, null, { ...ids }, true)
    //   }
    //   this.context.$changeOptionsEV(
    //     true,
    //     "isShow",
    //     false,
    //     null,
    //     {
    //       pageLayoutId: this.navMenuId
    //     },
    //     true
    //   )
    //   layoutId
    //     ? this.context.$changeOptionsEV(
    //         "77.2222%",
    //         "width",
    //         false,
    //         null,
    //         {
    //           pageLayoutId: layoutId
    //         },
    //         true
    //       )
    //     : ""
    // }
    // let navMenuData,
    //   targetData = []
    // navMenuData = this.restUrl.data.data.generalDataTypes
    // this.recursiveFindDataTypes(navMenuData, targetData)

    // this.context.$changeOptionsEV(targetData, "selectOptions", false, null, ids, true)
    // this.context.$changeOptionsEV(navMenuData[0]?.publicId, "value", false, null, ids, true)
    // this.initNavMenuWatcher(rectAttr.rect_id)
  }
  // 更新简介区域数据
  initIntroductionData(introduction, isShow, key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageIntroductionData(introduction, isShow)
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxNoteEditor") !== -1) {
          this.context.$subPageEvent.contexts[key].initListPageIntroductionData(introduction, isShow)
        }
      })
    }
  }
  // 递归找到数据分类层级
  recursiveFindDataTypes(navMenuData, targetData) {
    for (let key in navMenuData) {
      targetData.push({
        label: navMenuData[key].name,
        value: navMenuData[key].publicId,
        iconUrl: navMenuData[key].iconUrl,
        children: []
      })
      if (typeof navMenuData[key].subGeneralDataTypes == "object") {
        this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
      }
    }
  }
  // 初始化多级筛选组件
  initMultiFilterData(key) {
    if (
      this.context.$subPageEvent.contexts[key] &&
      (this.context.$subPageEvent.contexts[key].options?.pluginName?.includes("controlMulitiFilter") ||
      this.context.$subPageEvent.contexts[key].options?.pluginName?.includes("triggerMulitiFilter"))
    ) {
      this.initMultiFilterWatcher(this.context.$subPageEvent.contexts[key].options)
    } else if (
      this.context.$subPageEvent.contexts[key]
    ) {
      this.context.$subPageEvent.contexts[key].initListPageMultiFilterData(this)
      this.initMultiFilterWatcher(this.context.$subPageEvent.contexts[key].options)
    }
  }
  handleMultiFilterData(newVal, options) {
    let typeIdsArr = [],
      relIdsArr = [],
      isOr = false,
      groupTypeId = {}
    if (newVal?.length) {
      relIdsArr = []
      if (options.model === "tree") {
        newVal = [...newVal].reverse().filter(item => item.id)
        ;(typeIdsArr = [newVal[0]?.publicId || ""]), (relIdsArr = [newVal[0]?.relId || ""])
      } else if (options.model === "filter") {
        let subTypeIdsArr = []
        let subRelIdsArr = []
        let flag = false
        newVal.forEach(item => {
          if (item.active) {
            typeIdsArr.push(item.publicId)
            relIdsArr.push(item.relId)
          }
          if (item.children.length) {
            item.children.forEach(item1 => {
              if (item1.active && item1.label !== "全部") {
                flag = true
                subTypeIdsArr.push(item1.publicId)
                subRelIdsArr.push(item1.relId)
                // 后端说pid等于0时不传
                item1.pid !== "0" ? groupTypeId[item1.pid] ? groupTypeId[item1.pid] = groupTypeId[item1.pid] + ',' + item1.cid : groupTypeId[item1.pid] = item1.cid : groupTypeId = ""
              }
            })
          }
        })
        if (flag) {
          typeIdsArr = subTypeIdsArr
          relIdsArr = subRelIdsArr
          if (subTypeIdsArr.length > 1) {// 多个分类
            isOr = true
          }
        }
      } else {
        let flag = false
        newVal.forEach(item => {
          if (item.active) {
            typeIdsArr.push(item.publicId)
            relIdsArr.push(item.relId)
          }
          if (item.children.length) {
            item.children.forEach(item1 => {
              if (item1.active && item1.label !== "全部") {
                flag = true
                typeIdsArr.push(item1.publicId)
                relIdsArr.push(item1.relId)
                // 一帆让加上groupTypeId 多级筛选选择多个时取交集
                // 后端说pid等于0时不传
                item1.pid !== "0" ? groupTypeId[item1.pid] ? groupTypeId[item1.pid] = groupTypeId[item1.pid] + ',' + item1.cid : groupTypeId[item1.pid] = item1.cid : groupTypeId = ""
              }
            })
          }
        })
        if (flag && typeIdsArr.length > 1) {// 多个分类
          isOr = true
        }
      }
    }
    return {
      typeIdsArr,
      relIdsArr,
      isOr,
      groupTypeId
    }
  }
  // 初始化多级筛选
  initMultiFilterWatcher(options) {
    const self = this
    this.context.$watch(
      function () {
        return options.selectOptions
      },
      async function (newVal, oldVal) {
        let { typeIdsArr, relIdsArr, isOr, groupTypeId } = self.handleMultiFilterData(newVal, options)

        // 需要根据当前多级筛选选中的节点类型，决定显示内容
        const emptyLayoutComponent_rect_id = self.findComponent("emptyLayoutComponent")?.rect_id

        let flag = false
        if(options?.pluginName?.includes("controlMulitiFilter")) {
          flag = typeIdsArr.length > 0
        } else if(options?.pluginName?.includes("triggerMulitiFilter")) {
          for(let i in self.context.$subPageEvent.contexts) {
            if(self.context.$subPageEvent.contexts[i].options?.pluginName?.includes("controlMulitiFilter")) {
              const cOptions = self.context.$subPageEvent.contexts[i].options
              let { typeIdsArr } = self.handleMultiFilterData(cOptions.selectOptions, cOptions)
              flag = typeIdsArr.length === 0
            }
          }
        } else {
          flag = true
        }
        // 多级筛选样式2
        if (!options.moreFilter && typeIdsArr?.length > 0) {
          // 通知面包屑更新数据
          if (self.showBreadCrumbs) {
            self.getBreadCrumbsData(typeIdsArr[0]).then(res => {
              self.initBreadCrumbsData(res)
            })
          }
          const generalDataTypesItem = self.findCurrentNavMenuData(
            self.restUrl.data.data.generalDataTypes,
            typeIdsArr[0]
          )
          console.log("generalDataTypesItem :>>", generalDataTypesItem)
          if (!generalDataTypesItem) {
            return
          }
          self.getAssembleClassifylData(typeIdsArr[0], generalDataTypesItem)
          const { openType, showType, introduction } = generalDataTypesItem
          if (openType === 1) {
            switch (showType) {
              case 0:
              case 1: // 列表
                // 通知自由布局更新数据
                if(flag) {
                  self.context.$eventBus.$emit(
                    `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
                    {
                      typeIds: typeIdsArr,
                      relIds: relIdsArr,
                      isOr: isOr,
                      groupTypeId: isOr ? groupTypeId : ""
                    }
                  )
                }
                break
              case 2: // 简介
                self.initIntroductionData(introduction, true)
                break
              case 3: // 简介+列表
                // 通知自由布局更新数据
                if(flag) {
                  self.context.$eventBus.$emit(
                    `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
                    {
                      typeIds: typeIdsArr,
                      relIds: relIdsArr,
                      isOr: isOr,
                      groupTypeId: isOr ? groupTypeId : ""
                    }
                  )
                }
                self.initIntroductionData(introduction, true)
                break
              case 4:
                break
            }
          } else if(options?.pluginName?.includes("triggerMulitiFilter") && flag) {
            self.context.$eventBus.$emit(
              `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
              {
                typeIds: typeIdsArr,
                relIds: relIdsArr,
                isOr: isOr,
                groupTypeId: isOr ? groupTypeId : ""
              }
            )
          }
        } else {
          // 通知列表更新数据
          if(flag) {
            self.context.$eventBus.$emit(
              `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
              {
                typeIds: typeIdsArr,
                relIds: relIdsArr,
                isOr: isOr,
                groupTypeId: isOr ? groupTypeId : ""
              }
            )
          }
        }
      },
      {
        immediate: true
      }
    )
  }
  // 初始化数据列表组件
  initDataGrid(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageDataGridData(this)
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxDataGrid") !== -1) {
          this.context.$subPageEvent.contexts[key].initListPageDataGridData(this)
        }
      })
    }
  }
  setTitleComponentsIsShow(rectAttr, val, type) {
    let result = null
    result = findTabs(rectAttr, null, type)
    this.setTitleComponentsIsShowHandle(rectAttr, val, result, type)
    // 如果是移动端，找到控制导航的抽屉按钮
    if (type === "navMenuVertical" && this.request_prefix === "appStage") {
      result = findComponentByPluginName(rectAttr, "layoutTitleOptionDrawerPlugin")
      this.setTitleComponentsIsShowHandle(rectAttr, val, result, type)
    }
  }
  setTitleComponentsIsShowHandle(rectAttr, val, result, type) {
    if (result.directionIndex === null || result.elementInLayoutId === null) return
    const { directionIndex, elementInLayoutId } = result
    const activeLayoutTitle = {
      container_id: this.containerId,
      rect_id: rectAttr.rect_id,
      directionIndex: directionIndex,
      elementInLayoutId: elementInLayoutId,
      value: val
    }
    this.context.$store.dispatch(this.context.request_prefix + "/layoutTitleComponentDisplayHandle", activeLayoutTitle)
    // if (type === "breadCrumbs") {
    //   sessionStorage.setItem("hasBreadCrumbs", "1")
    // }
    // if (type === "navMenuVertical") {
    //   sessionStorage.setItem("hasNavMenuVertical", "1")
    // }
  }
  // 获取当前分类的详情数据
  async getClassifylDetail(typeId) {
    return this.context.$API.queryClassifyDetail({
      t: typeId ? typeId : 0,
      param: { ac: true }
    })
  }
  // 组装当前分类的详情数据
  async getAssembleClassifylData(typeId, generalData) {
    if (!this.isLocalData && !this.noGetClassify) return // 非本地数据不调用该方法 并且没有绑定插件
    // 获取当前分类的详情数据
    const tempData = this.noGetClassify ? generalData : await this.getClassifylDetail(typeId)
    if ((this.noGetClassify && generalData) || tempData?.data?.status === 200) {
      let _result = this.noGetClassify ? [generalData] : tempData.data.data ? [tempData.data.data] : []
      // 深拷贝_result
      _result = simpleDeepClone(_result)
      Object.keys(_result).forEach(key => {
        Object.keys(_result[key]).forEach(dataItemKey => {
          // 保留viewNum、name、updateTime字段
          if (dataItemKey === "viewNum" || dataItemKey === "name" || dataItemKey === "insertTime" || dataItemKey === "iconUrl" || dataItemKey === "topUrl" || dataItemKey === "introduction"|| dataItemKey === "time") {
            const componentShape = ["cxText", "cxButton", "imageComponent"]
            let str = {}
            str.componentShape = componentShape
            str.value = "" + _result[key][dataItemKey]
            if (dataItemKey === "viewNum") str.key = "浏览量"
            if (dataItemKey === "name") str.key = "分类名称"
            if (dataItemKey === "insertTime") str.key = "分类创建时间"
            if (dataItemKey === "iconUrl") str.key = "分类图标"
            if (dataItemKey === "topUrl") str.key = "分类广告图"
            if (dataItemKey === "introduction") str.key = "简介"
            if (dataItemKey === "time") str.key = "分类发布时间"
            _result[key][dataItemKey] = str
            return
          }
          if (isNaN(dataItemKey)) {
            delete _result[key][dataItemKey]
          } else {
            if (isFieldAllEmpty(_result, dataItemKey)) {
              delete _result[key][dataItemKey]
            } else {
              const componentShape = fixComponent(dataItemKey, _result[key][dataItemKey].value)
              _result[key][dataItemKey].component_shape = componentShape
            }
          }
        })
        _result[key].appName = this.appNameStr
      })
      window.localStorage.setItem(`classifyDetailData-` + this.appId, JSON.stringify(_result))
      this.context.$eventBus.$emit("classifyDetailDataUpdate")
    }
  }
  handleListPageSetting(type) {
    console.log("handleListPageSetting>>")
    const subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    const value = subPage.listPageSetting[type]
    // 更新变量
    this[type] = value
    if (type === "showBreadCrumbs") {
      // 老数据兼容
      const emptyLayout = this.findComponent("emptyLayoutComponent")
      this.setTitleComponentsIsShow(emptyLayout, value, "breadCrumbs")

      const rectAttr = this.findComponent("cxBreadCrumbs")
      if (!rectAttr) return
      this.initBreadCrumbsData()
    }
    if (type === "showNavMenu") {
      // 老数据兼容
      const emptyLayout = this.findComponent("emptyLayoutComponent")
      this.setTitleComponentsIsShow(emptyLayout, value, "navMenuVertical")

      let rectAttr = this.findComponent("cxNavMenuVertical")
      if (!rectAttr) return
      this.initNavMenuData()
    }
    if (type === "showSearchComponent") {
      const rectAttr = this.findSearchComponent()
      if (!rectAttr) return
      const ids = {
        container_id: this.containerId,
        rect_id: rectAttr.rect_id
      }
      this.context.$changeOptionsEV(value ? 100 : 0, "opacity", false, null, { ...ids }, true)
    }
  }
  clickSearchButton() {
    const simpleSearchComponet = this.findSearchComponent()
    const uid = simpleSearchComponet.options?.rows[0]?.cols[0]?.uid
    const emptyLayoutComponent_rect_id = this.findComponent("emptyLayoutComponent")?.rect_id
    // 获取当前搜索的值
    const options = this.context.$getOptions({
      container_id: this.containerId,
      rect_id: simpleSearchComponet.rect_id,
      uid: uid,
      elementInLayoutId: simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions?.find(item => item.innerElement === "cxInput").elementInLayoutId
    })
    const searchInputValue = options.inputValue
    console.log("searchInputValue>>>", searchInputValue)

    // 通知自由布局更新数据
    this.context.$eventBus.$emit(`update-layout-data-eventBus-${this.containerId}-${emptyLayoutComponent_rect_id}`, {
      searchValue: searchInputValue
    })
  }
  removeEventTrigger() {
    const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
    if (searchButton) {
      searchButton.removeEventListener("click", this.clickSearchButtonBind, true)
    }
  }
}
export default {
  methods: {
    listPagePlugin() {
      const listPage = new ListPage(this)
      this.listPage = listPage
      listPage.init()
    },
    handleListPageSetting(type) {
      this.listPage?.handleListPageSetting(type)
    }
  },
  beforeDestroy() {
    this.listPage?.removeEventTrigger()
  }
}
